import classNames from 'classnames'

import { getLocalLastUserConfig } from 'client/services'
import { DEFAULT_THEME } from 'client/utils'

import { type Size, DEBUG_MODE } from '..'

import styles from './app-divider.module.scss'

export type AppDividerProps = {
  size?: Size
  border?: boolean | 'weak' | 'normal' | 'strong'
}

const AppDivider = (props: AppDividerProps) => {
  const theme = getLocalLastUserConfig().theme || DEFAULT_THEME

  const { size = 'medium', border = false } = props

  const Base = () => (
    <div
      data-testid="app-divider"
      className={classNames(
        styles.appDivider,
        styles[theme],
        styles[size],
        border &&
          ((border === true && styles['border_normal']) || styles[`border_${border}`])
      )}
    />
  )

  if (DEBUG_MODE) {
    return (
      <div className={styles.appDividerContainer} data-testid="app-divider-container">
        <div className={styles.size}>{size}</div>
        <Base />
      </div>
    )
  }

  return <Base />
}

export default AppDivider
